import Pickr from '@simonwep/pickr/dist/pickr.min';

window.Pickr = Pickr;
